// extracted by mini-css-extract-plugin
export default {"container":"TabBar_container__N8cGK","tabs":"TabBar_tabs__zFz3W","tab":"TabBar_tab__ZXzNS","active":"TabBar_active__USga2","searchCount":"TabBar_searchCount__KUNS4"};